import { useQuery } from '@tanstack/react-query';

import { transcriptMetadataOptions } from '@/entities/transcript';

import { useIsGenerating } from './use-is-generating';

export const useIsGenerationAvailable = (sessionId: string) => {
    const isGenerating = useIsGenerating(sessionId);
    const { data: metadata, isPending: isPendingMetadata } = useQuery(
        transcriptMetadataOptions(sessionId),
    );

    return !isGenerating && !isPendingMetadata && !!metadata;
};
